import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "@emotion/styled";
import { withTheme } from "@emotion/react";
import { darken } from "polished";
import { Search as SearchIcon } from "react-feather";
import { useTranslation } from "react-i18next";
import MyLogoLight from "../../vendor/ME_Light.png";
import MyLogoDark from "../../vendor/ME_Dark.png";

import {
  Grid,
  InputBase,
  AppBar as MuiAppBar,
  IconButton as MuiIconButton,
  Toolbar,
  Link,
} from "@mui/material";

import { Menu as MenuIcon, RequestPage } from "@mui/icons-material";

import NavbarNotificationsDropdown from "./NavbarNotificationsDropdown";
import NavbarMessagesDropdown from "./NavbarMessagesDropdown";
// import NavbarLanguagesDropdown from "./NavbarLanguagesDropdown";
import NavbarUserDropdown from "./NavbarUserDropdown";
import NavbarThemeDropdown from "./NavbarThemeSwitch";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import { SquareCheckBig } from "lucide-react";
import SupportDrawer from "../../pages/pages/supporthub/components/SupportDrawer";
import { API_BASE_URL } from "../../config";
import { ticketService } from "../../pages/pages/supporthub/services/ticketService";
import { setIssueFilters } from "../../redux/slices/issueFilters";

const AppBar = styled(MuiAppBar)`
  background: ${(props) => props.theme.header.background};
  color: ${(props) => props.theme.header.color};
`;

const IconButton = styled(MuiIconButton)`
  svg {
    width: 22px;
    height: 22px;
  }
`;

const Search = styled.div`
  border-radius: 2px;
  background-color: ${(props) => props.theme.header.background};
  display: none;
  position: relative;
  width: 100%;

  &:hover {
    background-color: ${(props) => darken(0.05, props.theme.header.background)};
  }

  ${(props) => props.theme.breakpoints.up("md")} {
    display: block;
  }
`;

const SearchIconWrapper = styled.div`
  width: 50px;
  height: 100%;
  position: absolute;
  pointer-events: none;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 22px;
    height: 22px;
  }
`;

const Input = styled(InputBase)`
  color: inherit;
  width: 100%;

  > input {
    color: ${(props) => props.theme.header.search.color};
    padding-top: ${(props) => props.theme.spacing(2.5)};
    padding-right: ${(props) => props.theme.spacing(2.5)};
    padding-bottom: ${(props) => props.theme.spacing(2.5)};
    padding-left: ${(props) => props.theme.spacing(12)};
    width: 160px;
  }
`;

const LogoImage = styled.img`
  width: auto;
  height: 40px;
  display: block;
  margin: auto;
  padding: 4px 30px;
  ${(props) => props.theme.breakpoints.down("sm")} {
    display: none;
  }
`;

const Navbar = ({ onDrawerToggle, theme }) => {
  const { t } = useTranslation();
  const logoSrc = theme.palette.mode === "dark" ? MyLogoDark : MyLogoLight;
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();

  const handleLogoClick = () => {
    const token = sessionStorage.getItem("token");

    // If no token exists, redirect to login
    if (!token) {
      navigate("/auth/sign-in");
      return;
    }

    // Token exists, navigate to private
    // The backend API will validate the token and return status === -1 if expired
    // The useAuth hooks will then handle the redirect to login
    navigate("/private");
  };

  return (
    <React.Fragment>
      <AppBar position="sticky" elevation={0}>
        <Toolbar>
          <Grid container alignItems="center">
            <Grid item sx={{ display: { xs: "block" } }}>
              <IconButton
                color="inherit"
                aria-label="Open drawer"
                onClick={onDrawerToggle}
                size="large"
              >
                <MenuIcon />
              </IconButton>
            </Grid>
            <Grid item>
              <Link onClick={handleLogoClick}>
                <LogoImage src={logoSrc} />
              </Link>
            </Grid>
            <Grid item>
              <Search>
                <SearchIconWrapper>
                  <SearchIcon />
                </SearchIconWrapper>
                <Input placeholder={t("Search")} />
              </Search>
            </Grid>
            <Grid item xs />
            <Grid item>
              <IconButton
                color="inherit"
                aria-label="Open drawer"
                onClick={() => setOpen(true)}
                size="large"
              >
                <RequestPage />
              </IconButton>
              <IconButton
                color="inherit"
                aria-label="Open drawer"
                onClick={() => navigate("/pages/richieste")}
                size="large"
              >
                <SquareCheckBig />
              </IconButton>
              <NavbarMessagesDropdown />
              <NavbarNotificationsDropdown />
              <NavbarThemeDropdown />
              {/* <NavbarLanguagesDropdown /> */}
              <NavbarUserDropdown />
            </Grid>
          </Grid>
        </Toolbar>
        <SupportDrawer open={open} setOpen={setOpen} />
      </AppBar>
    </React.Fragment>
  );
};

export default withTheme(Navbar);
